import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.32 5.325a1.126 1.126 0 000 1.572L10.366 10 7.32 13.103a1.126 1.126 0 000 1.572 1.077 1.077 0 001.542 0l3.819-3.89a1.126 1.126 0 000-1.57l-3.819-3.89a1.077 1.077 0 00-1.542 0z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
